import { FC } from "react";
import { ActionIcon, Tooltip } from "@mantine/core";
import { IconBrandWhatsapp } from "@tabler/icons-react";
import Helper from "@/utils/helper";

const WhatsappIcon: FC<{ number: string }> = ({ number }: any) => {

    if (Helper.isNullOrWhitespace(number)) {
        return null;
    }

    const handleClick = (e: any) => {
        e.stopPropagation();

        let phone = number.replace(/\D/g, '');
        if (phone.startsWith('0')) {
            phone = '27' + phone.substring(1);
        }

        const url = `https://wa.me/${phone}`;
        window.open(url, '_blank');
    };

    return (
        <Tooltip label={'Chat via whatsapp'} color={'scBlue'}>
            <ActionIcon variant={'transparent'} onClick={handleClick}>
                <IconBrandWhatsapp size={18} color={'#25D366'} />
            </ActionIcon>
        </Tooltip>
    );
};

export default WhatsappIcon;
